import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useSupport () {
    const [contactMessageResponse, setContactMessageResponse] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const contactMessageApi = useApi('support/contactmessage');
    const contactMessageLoad = useRef(true);

    useEffect(() => {
        if (contactMessageLoad.current) {
            contactMessageLoad.current = false;
            return;
        }

        setContactMessageResponse(contactMessageApi.data);
        setLoading(contactMessageApi.loading);
        setError(contactMessageApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactMessageApi]);

    const sendContactMessage = async (name, email, message) => {
        setLoading(true);
        contactMessageApi.jsonPost({
            name: name,
            email: email,
            message: message
        });
    }

    return {
        contactMessageResponse,
        error,
        loading,
        sendContactMessage
    };
}

export default useSupport;